// extracted by mini-css-extract-plugin
export var disabled = "_r-6";
export var hierarchyLinkGray = "_r-a";
export var hierarchyLinkUnderline = "_r-9";
export var hierarchyPrimary = "_r-0";
export var hierarchySecondary = "_r-7";
export var hierarchyTertiary = "_r-8";
export var pressed = "_r-2";
export var themeAction = "_r-1";
export var themeDestructive = "_r-4";
export var themeNormal = "_r-3";
export var themeSuccess = "_r-5";